import React from "react";
import useQueryURL from "../../../common/hooks/useQueryURL";
import ModalDrawer from "../../../common/components/organisme/ModalDrawer/ModalDrawer";
import { SingleChargingSession } from "../../../features/chargingSession/components/SingleChargingSession";
import TextBox from "../../../common/components/molecule/TextBox/TextBox";
import SingleClient from "../../../features/clients/components/SingleClient";
import { SingleStation } from "../../../features/stations/components/SingleStation";
import SingleOrganization from "../../../features/organization/components/SingleOrganization";
import CodeBox from "../../../common/components/atom/CodeBox/CodeBox";
import useNavigationApp from "../../../navigation/useNavigationApp";

export const SINGLE_CHARGE_SESSION_MODAL_ID = "single-chse-modal";
export default function SingleChargingSessionPage() {
  const navigate = useNavigationApp();
  return (
    <div>
      <div
        style={{
          height: "150px",
          marginBottom: "50px",
          display: "flex",
          gap: "20px",
        }}
      >
        <TextBox
          content={[
            {
              title: "Créer le",
              TextRender: () => (
                <SingleChargingSession.Info info="cs_create_at" />
              ),
            },
            {
              title: "Client",
              TextRender: () => (
                <SingleChargingSession.Info
                  info="cs_client"
            
                  renderComponent={({ value }) => (
                    <>
                      {value === "" ? <>
                        <SingleChargingSession.Info info="cs_client_number_phone" /></>:
                      <>
                      <SingleClient.Info info={"client_firstname"} id={value} emptyText="Aucun client" />{" "}
                      <SingleClient.Info info={"client_lastname"} id={value} emptyText="" />
                      </>
                  }
                    </>
                  )}
                />
              ),
            },
          ]}
        />

        <TextBox
          content={[
            {
              title: "Prix",
              TextRender: () => (
                <>
                  <SingleChargingSession.Info info="cs_price" />
                  <SingleChargingSession.Info info="cs_currency" />
                </>
              ),
            },
            {
              title: "kWh",
              TextRender: () => (
                <>
                  <SingleChargingSession.Info info="cs_nb_kwh" />
                </>
              ),
            },
          ]}
        />
      </div>

      <div
        style={{
          height: "60px",
          marginBottom: "50px",
          display: "flex",
          gap: "20px",
        }}
      >
        <SingleChargingSession.Info
          info="cs_station"
          renderComponent={({ value }) => (
            <TextBox
              onClick={() => {
                navigate.goToSingleStation(value);
              }}
              content={[
                {
                  title: "Station",
                  TextRender: () => <SingleStation.Name idStation={value} />,
                },
              ]}
            />
          )}
        />

        <SingleChargingSession.Info
          info="cs_organization"

          renderComponent={({ value }) => (
            <TextBox
            onClick={() => {
              navigate.goToSingleOrganization(value);
            }}
              content={[
                {
                  title: "Organisation",
                  TextRender: () => (
                    <SingleOrganization.Name organizationId={value} />
                  ),
                },
              ]}
            />
          )}
        />
      </div>
      <div
        style={{
          height: "60px",
          marginBottom: "50px",
          display: "flex",
          gap: "20px",
        }}
      >
        <SingleChargingSession.Info
          info="cs_paygo"
          renderComponent={({ value }) => (
            <TextBox
              onClick={() => {
                navigate.goToSinglePayGo(value, { keepURL: false });
              }}
              content={[
                {
                  title: "Paygo code",
                  TextRender: () => (
                    <SingleChargingSession.Info
                      info="cs_paygo_code"
                      renderComponent={({ value }) => (
                        <>
                          <CodeBox code={value} />
                        </>
                      )}
                    />
                  ),
                },
              ]}
            />
          )}
        />
      </div>
    </div>
  );
}

export const SingleChargingSessionPageDrawer = ({
  modalId,
}: {
  modalId?: string;
}) => {
  const modalIdFound = modalId || SINGLE_CHARGE_SESSION_MODAL_ID;
  const { removeQueryValue } = useQueryURL();
  const onClose = () => {
    removeQueryValue(["transactionId", modalIdFound]);
  };

  return (
    <>
      <ModalDrawer
        urlParamName={modalIdFound}
        title={"Rechargement"}
        onClose={onClose}
      >
        <SingleChargingSessionPage />
      </ModalDrawer>
    </>
  );
};
